module.exports = __webpack_public_path__ + "img/espanha-flag-disabled.7d83be09.png";